import { StatsigClient } from '@statsig/react-bindings';
import type { AuthState } from '../store/slices/authSlice';

export const determineNextOnboardingRoute = (authState: AuthState, statsigClient: StatsigClient): string => {
  if (!authState.isOnboardingComplete) {
    if (!authState.inviteVerified) {
      return '/onboarding/check-invite-code';
    }

    if (!authState.displayName || !authState.dateOfBirth) {
      return '/onboarding/add-display-name-and-birthday';
    }

    if (!authState.phoneNumber) {
      return '/onboarding/addPhoneNumber';
    }

    if (!authState.inviterQuestionAnswered) {
      return '/onboarding/answer-inviter-question';
    }
  }

  // If user has not uploaded a profile picture, redirect to add profile picture page
  if (!authState.profilePic && !authState.hasSkippedProfilePic) {
    const defer = localStorage.getItem('deferProfilePicUpload');
    const deferredTime = new Date(defer ?? '0');
    if (deferredTime.getTime() + 1000 * 60 * 10 < Date.now()) {
      localStorage.removeItem('deferProfilePicUpload');
      return '/onboarding/addProfilePicture';
    }
  }

  if (location.pathname !== '/inbox' && !authState.isOnBoardingTutorialComplete) {
    return '/inbox';
  }

  // Onboarding complete, redirect to home
  return '/';
};
